import { UploadFileTypesEnum } from 'CorePackage/MainModule/enums/UploadFileTypesEnum';

export const importFileTypesTestExecErknm: (keyof typeof UploadFileTypesEnum)[] = [
  'ERKNM_PLAN_CORRECTION',
  'ERKNM',
  'ERKNM_CORRECTION',
];
